import request from '@/utils/request'

//敏感词校验
export function CheckSensitiveWords(data) {
    return new Promise((resolve, reject) => {
        return request.post({
            url: '/WebCommon/CheckSensitiveWords',
            data: data
        }).then(res => {
            if (res) {
              resolve(res)
            }
        }).catch(err => {
            console.log(err);
            reject(err)
        });
    });
}

// 类别
export function GetDictionary(data) {
    return new Promise((resolve, reject) => {
        return request.post({
            url: '/WebCommon/GetDictionary',
            data: data
        }).then(res => {
            if (res) {
              resolve(res)
            }
        }).catch(err => {
            console.log(err);
            reject(err)
        });
    });
}

// 国外地区
export function GetForeignCountry(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebCommon/GetCountry',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 城市-带ABC分类
export function GetHotCitys(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebCommon/GetHotCitys',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 根据城市查询区县
export function GetCounty(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebCommon/GetCounty',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 获取城市级联
export function GetWebCascader(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebCommon/GetWebCascader',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 获取城市级联（省市区）
export function GetAllWebCascader  (data) {
    return new Promise((resolve, reject) => {
        return request.post({
            url: '/WebCommon/GetAllWebCascader',
            data: data
        }).then(res => {
            if (res) {
              resolve(res)
            }
        }).catch(err => {
            console.log(err);
            reject(err)
        });
    });
  }

// 获取网站配置项
export function GetWebConfig(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebCommon/GetWebConfig',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 判断求职意向是否填写
export function GetJobIntention(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebPosition/GetJobIntention',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 消息数量
export function GetUserNotificationCount(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebUser/GetUserNotificationCount',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 获取会话顶部用户信息
export function GetPositonByUserId(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebUser/GetPositonByUserId',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

// 获取会话顶部用户信息
export function GetConversationInfo(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebUserCompany/GetConversationInfo',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}

export function GetSystemConfig(data) {
  return new Promise((resolve, reject) => {
      return request.post({
          url: '/WebLogin/GetSystemConfig',
          data: data
      }).then(res => {
          if (res) {
            resolve(res)
          }
      }).catch(err => {
          console.log(err);
          reject(err)
      });
  });
}